<template>
  <div class="moduleSelection">
    <dx-radio-check
      :id="config.id"
      :name="config.id"
      :value="value"
      :checked="value"
      :label="translatedLabel"
      :disabled="config.readonly"
      :error="translatedError"
      type="checkbox"
      @input="update"
    />
    <button
      v-if="hasModalContent"
      class="infoPopupButton"
      type="button"
      @click="openPopupModal"
    >
      <info-icon :height="22" :width="22" />
    </button>

    <p class="description">{{ $t(`${translationKeyPrefix}.infoText`) }}</p>

    <dx-popup-modal ref="popupModal">
      <dx-content-block-renderer :content-blocks="contentBlocks" />
    </dx-popup-modal>
  </div>
</template>

<script>
import {
  DxRadioCheck,
  DxPopupModal,
} from '@sumcumo/dextra-frontend-component-lib'

import infoModalModuleKey from '~/domains/application/__gql__/queries/infoModalModuleKey.gql'

import DxContentBlockRenderer from '~/components/DX-ContentBlockRenderer'
import InfoIcon from '~/components/icons/InfoIcon'

export default {
  name: 'DXModuleSelectionAdapter',
  components: {
    DxContentBlockRenderer,
    DxRadioCheck,
    DxPopupModal,
    InfoIcon,
  },
  props: {
    config: {
      type: Object,
      default: () => ({}),
    },
    value: {
      type: Boolean,
      default: true,
    },
    error: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      contentBlocks: [],
    }
  },

  computed: {
    translationKeyPrefix() {
      if (this.config.source) {
        return `modules.${this.config.source.key}`
      }

      return ''
    },

    translatedLabel() {
      return this.$t(`${this.translationKeyPrefix}.label`)
    },

    translatedError() {
      return this.error
        ? this.$t(`errors.module.${this.error.type}`, {
            ...this.error.params,
            label: this.translatedLabel,
          })
        : null
    },

    hasModalContent() {
      return this.contentBlocks.length > 0
    },
  },

  mounted() {
    this.fetchModalContent()
  },

  methods: {
    update(value) {
      this.$emit('input', !value)
    },

    openPopupModal() {
      this.$refs.popupModal.open()
    },

    async fetchModalContent() {
      const { data } = await this.$apolloProvider.clients.cms.query({
        query: infoModalModuleKey,
        variables: {
          where: {
            moduleKey: this.config.source.key,
            productKey: this.$route.query.key,
            productVariantKey: this.$route.query.variantKey,
            // @TODO I could not reference the version number, this has to become a variable at some point.
            productVersionNumber: '1',
          },
          locales: [this.$i18n.locale],
        },
      })

      if (data?.infoModalsConnection?.edges.length > 0) {
        this.contentBlocks =
          data.infoModalsConnection.edges[0].node.modalContent
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@sumcumo/dextra-frontend-component-lib/dist/assets/styles/variables/colors';
@import '~@sumcumo/dextra-frontend-component-lib/dist/assets/styles/variables/typo';
@import '~@sumcumo/dextra-frontend-component-lib/dist/assets/styles/functions/px-to-rem';

.moduleSelection {
  display: grid;
  margin-top: rem(8);
  grid-column-gap: rem(4);
  grid-template-columns: 1fr rem(32);

  ::v-deep .cmp-checkbox::after {
    border-color: $color-turquoise-surf !important;
  }
}

.infoPopupButton {
  margin-bottom: rem(7);
  border: none;
  padding: 0 rem(4);
  background: transparent;
  color: $functional-clr-info-dk;
}

.description {
  margin: 0;
  grid-column: 1 / -1;
}
</style>
